/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A high precision floating point value represented as a string */
  BigFloat: { input: any; output: any; }
  /** An arbitrary size integer represented as a string */
  BigInt: { input: string; output: string; }
  /** An opaque string using for tracking a position in results during pagination */
  Cursor: { input: string; output: string; }
  /** A date without time information */
  Date: { input: any; output: any; }
  /** A date and time */
  Datetime: { input: string; output: string; }
  /** A Javascript Object Notation value serialized as a string */
  JSON: { input: string; output: string; }
  /** Any type not handled by the type system */
  Opaque: { input: string; output: string; }
  /** A time without date information */
  Time: { input: any; output: any; }
  /** A universally unique identifier */
  UUID: { input: string; output: string; }
};

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars['BigFloat']['input']>;
  gt?: InputMaybe<Scalars['BigFloat']['input']>;
  gte?: InputMaybe<Scalars['BigFloat']['input']>;
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigFloat']['input']>;
  lte?: InputMaybe<Scalars['BigFloat']['input']>;
  neq?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  neq?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  contains?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Date']['input']>>;
  contains?: InputMaybe<Array<Scalars['Date']['input']>>;
  eq?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars['Datetime']['input']>;
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
  neq?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  contains?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  eq?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export enum FilterIs {
  NotNull = 'NOT_NULL',
  Null = 'NULL'
}

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Float']['input']>>;
  contains?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The root type for creating and mutating data */
export type Mutation = {
  __typename?: 'Mutation';
  debug_auth_uid?: Maybe<Scalars['UUID']['output']>;
  /** Deletes zero or more records from the `audio` collection */
  deleteFromaudioCollection: AudioDeleteResponse;
  /** Deletes zero or more records from the `contact` collection */
  deleteFromcontactCollection: ContactDeleteResponse;
  /** Deletes zero or more records from the `event` collection */
  deleteFromeventCollection: EventDeleteResponse;
  /** Deletes zero or more records from the `event_member` collection */
  deleteFromevent_memberCollection: Event_MemberDeleteResponse;
  /** Deletes zero or more records from the `event_ticket_kind` collection */
  deleteFromevent_ticket_kindCollection: Event_Ticket_KindDeleteResponse;
  /** Deletes zero or more records from the `feed` collection */
  deleteFromfeedCollection: FeedDeleteResponse;
  /** Deletes zero or more records from the `file` collection */
  deleteFromfileCollection: FileDeleteResponse;
  /** Deletes zero or more records from the `notification` collection */
  deleteFromnotificationCollection: NotificationDeleteResponse;
  /** Deletes zero or more records from the `profile` collection */
  deleteFromprofileCollection: ProfileDeleteResponse;
  /** Deletes zero or more records from the `prompt` collection */
  deleteFrompromptCollection: PromptDeleteResponse;
  /** Deletes zero or more records from the `video` collection */
  deleteFromvideoCollection: VideoDeleteResponse;
  /** Adds one or more `audio` records to the collection */
  insertIntoaudioCollection?: Maybe<AudioInsertResponse>;
  /** Adds one or more `contact` records to the collection */
  insertIntocontactCollection?: Maybe<ContactInsertResponse>;
  /** Adds one or more `event` records to the collection */
  insertIntoeventCollection?: Maybe<EventInsertResponse>;
  /** Adds one or more `event_member` records to the collection */
  insertIntoevent_memberCollection?: Maybe<Event_MemberInsertResponse>;
  /** Adds one or more `event_ticket_kind` records to the collection */
  insertIntoevent_ticket_kindCollection?: Maybe<Event_Ticket_KindInsertResponse>;
  /** Adds one or more `feed` records to the collection */
  insertIntofeedCollection?: Maybe<FeedInsertResponse>;
  /** Adds one or more `file` records to the collection */
  insertIntofileCollection?: Maybe<FileInsertResponse>;
  /** Adds one or more `notification` records to the collection */
  insertIntonotificationCollection?: Maybe<NotificationInsertResponse>;
  /** Adds one or more `profile` records to the collection */
  insertIntoprofileCollection?: Maybe<ProfileInsertResponse>;
  /** Adds one or more `prompt` records to the collection */
  insertIntopromptCollection?: Maybe<PromptInsertResponse>;
  /** Adds one or more `video` records to the collection */
  insertIntovideoCollection?: Maybe<VideoInsertResponse>;
  pgmq_archive?: Maybe<Scalars['Boolean']['output']>;
  pgmq_send?: Maybe<Scalars['BigInt']['output']>;
  pgmq_send_delay?: Maybe<Scalars['BigInt']['output']>;
  process_notification_retries?: Maybe<Scalars['Opaque']['output']>;
  send_friend_retargeting_notifications?: Maybe<Scalars['Opaque']['output']>;
  send_weekly_neighborhood_notifications?: Maybe<Scalars['Opaque']['output']>;
  /** Updates zero or more records in the `audio` collection */
  updateaudioCollection: AudioUpdateResponse;
  /** Updates zero or more records in the `contact` collection */
  updatecontactCollection: ContactUpdateResponse;
  /** Updates zero or more records in the `event` collection */
  updateeventCollection: EventUpdateResponse;
  /** Updates zero or more records in the `event_member` collection */
  updateevent_memberCollection: Event_MemberUpdateResponse;
  /** Updates zero or more records in the `event_ticket_kind` collection */
  updateevent_ticket_kindCollection: Event_Ticket_KindUpdateResponse;
  /** Updates zero or more records in the `feed` collection */
  updatefeedCollection: FeedUpdateResponse;
  /** Updates zero or more records in the `file` collection */
  updatefileCollection: FileUpdateResponse;
  /** Updates zero or more records in the `notification` collection */
  updatenotificationCollection: NotificationUpdateResponse;
  /** Updates zero or more records in the `profile` collection */
  updateprofileCollection: ProfileUpdateResponse;
  /** Updates zero or more records in the `prompt` collection */
  updatepromptCollection: PromptUpdateResponse;
  /** Updates zero or more records in the `video` collection */
  updatevideoCollection: VideoUpdateResponse;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromaudioCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<AudioFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromcontactCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ContactFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromeventCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<EventFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromevent_MemberCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Event_MemberFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromevent_Ticket_KindCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Event_Ticket_KindFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromfeedCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<FeedFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromfileCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<FileFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromnotificationCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<NotificationFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromprofileCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ProfileFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFrompromptCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<PromptFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromvideoCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<VideoFilter>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoaudioCollectionArgs = {
  objects: Array<AudioInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntocontactCollectionArgs = {
  objects: Array<ContactInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoeventCollectionArgs = {
  objects: Array<EventInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoevent_MemberCollectionArgs = {
  objects: Array<Event_MemberInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoevent_Ticket_KindCollectionArgs = {
  objects: Array<Event_Ticket_KindInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntofeedCollectionArgs = {
  objects: Array<FeedInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntofileCollectionArgs = {
  objects: Array<FileInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntonotificationCollectionArgs = {
  objects: Array<NotificationInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoprofileCollectionArgs = {
  objects: Array<ProfileInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntopromptCollectionArgs = {
  objects: Array<PromptInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntovideoCollectionArgs = {
  objects: Array<VideoInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationPgmq_ArchiveArgs = {
  message_id: Scalars['BigInt']['input'];
  queue_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationPgmq_SendArgs = {
  message: Scalars['JSON']['input'];
  queue_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationPgmq_Send_DelayArgs = {
  delay_seconds: Scalars['Int']['input'];
  message: Scalars['JSON']['input'];
  queue_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdateaudioCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<AudioFilter>;
  set: AudioUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatecontactCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ContactFilter>;
  set: ContactUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateeventCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<EventFilter>;
  set: EventUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateevent_MemberCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Event_MemberFilter>;
  set: Event_MemberUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateevent_Ticket_KindCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Event_Ticket_KindFilter>;
  set: Event_Ticket_KindUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatefeedCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<FeedFilter>;
  set: FeedUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatefileCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<FileFilter>;
  set: FileUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatenotificationCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<NotificationFilter>;
  set: NotificationUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateprofileCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<ProfileFilter>;
  set: ProfileUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatepromptCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<PromptFilter>;
  set: PromptUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatevideoCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<VideoFilter>;
  set: VideoUpdateInput;
};

export type Node = {
  /** Retrieves a record by `ID` */
  nodeId: Scalars['ID']['output'];
};

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars['Opaque']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Defines a per-field sorting order */
export enum OrderByDirection {
  /** Ascending order, nulls first */
  AscNullsFirst = 'AscNullsFirst',
  /** Ascending order, nulls last */
  AscNullsLast = 'AscNullsLast',
  /** Descending order, nulls first */
  DescNullsFirst = 'DescNullsFirst',
  /** Descending order, nulls last */
  DescNullsLast = 'DescNullsLast'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The root type for querying data */
export type Query = {
  __typename?: 'Query';
  /** A pagable collection of type `audio` */
  audioCollection?: Maybe<AudioConnection>;
  /** A pagable collection of type `contact` */
  contactCollection?: Maybe<ContactConnection>;
  /** A pagable collection of type `event` */
  eventCollection?: Maybe<EventConnection>;
  /** A pagable collection of type `event_member` */
  event_memberCollection?: Maybe<Event_MemberConnection>;
  /** A pagable collection of type `event_ticket_kind` */
  event_ticket_kindCollection?: Maybe<Event_Ticket_KindConnection>;
  /** A pagable collection of type `feed` */
  feedCollection?: Maybe<FeedConnection>;
  /** A pagable collection of type `file` */
  fileCollection?: Maybe<FileConnection>;
  /** Retrieve a record by its `ID` */
  node?: Maybe<Node>;
  /** A pagable collection of type `notification` */
  notificationCollection?: Maybe<NotificationConnection>;
  /** A pagable collection of type `profile` */
  profileCollection?: Maybe<ProfileConnection>;
  /** A pagable collection of type `prompt` */
  promptCollection?: Maybe<PromptConnection>;
  /** A pagable collection of type `spatial_ref_sys` */
  spatial_ref_sysCollection?: Maybe<Spatial_Ref_SysConnection>;
  user_owns_video?: Maybe<Scalars['Boolean']['output']>;
  /** A pagable collection of type `video` */
  videoCollection?: Maybe<VideoConnection>;
};


/** The root type for querying data */
export type QueryAudioCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AudioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AudioOrderBy>>;
};


/** The root type for querying data */
export type QueryContactCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContactOrderBy>>;
};


/** The root type for querying data */
export type QueryEventCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventOrderBy>>;
};


/** The root type for querying data */
export type QueryEvent_MemberCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Event_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Event_MemberOrderBy>>;
};


/** The root type for querying data */
export type QueryEvent_Ticket_KindCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Event_Ticket_KindFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Event_Ticket_KindOrderBy>>;
};


/** The root type for querying data */
export type QueryFeedCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FeedFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeedOrderBy>>;
};


/** The root type for querying data */
export type QueryFileCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOrderBy>>;
};


/** The root type for querying data */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root type for querying data */
export type QueryNotificationCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderBy>>;
};


/** The root type for querying data */
export type QueryProfileCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileOrderBy>>;
};


/** The root type for querying data */
export type QueryPromptCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptOrderBy>>;
};


/** The root type for querying data */
export type QuerySpatial_Ref_SysCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Spatial_Ref_SysFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Spatial_Ref_SysOrderBy>>;
};


/** The root type for querying data */
export type QueryUser_Owns_VideoArgs = {
  p_user_id: Scalars['UUID']['input'];
  p_video_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryVideoCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<VideoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VideoOrderBy>>;
};

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  iregex?: InputMaybe<Scalars['String']['input']>;
  is?: InputMaybe<FilterIs>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  neq?: InputMaybe<Scalars['Time']['input']>;
};

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Time']['input']>>;
  contains?: InputMaybe<Array<Scalars['Time']['input']>>;
  eq?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contains?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eq?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type Audio = Node & {
  __typename?: 'audio';
  created_at: Scalars['Datetime']['output'];
  delivered_at?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  is_deleted: Scalars['Boolean']['output'];
  listened_at?: Maybe<Scalars['Datetime']['output']>;
  md5_checksum?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notificationCollection?: Maybe<NotificationConnection>;
  to_user_id: Scalars['UUID']['output'];
  transcription?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user_id: Scalars['UUID']['output'];
  video?: Maybe<Video>;
  video_id: Scalars['UUID']['output'];
};


export type AudioNotificationCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderBy>>;
};

export type AudioConnection = {
  __typename?: 'audioConnection';
  edges: Array<AudioEdge>;
  pageInfo: PageInfo;
};

export type AudioDeleteResponse = {
  __typename?: 'audioDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Audio>;
};

export type AudioEdge = {
  __typename?: 'audioEdge';
  cursor: Scalars['String']['output'];
  node: Audio;
};

export type AudioFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AudioFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  delivered_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_deleted?: InputMaybe<BooleanFilter>;
  listened_at?: InputMaybe<DatetimeFilter>;
  md5_checksum?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AudioFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AudioFilter>>;
  to_user_id?: InputMaybe<UuidFilter>;
  transcription?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
  video_id?: InputMaybe<UuidFilter>;
};

export type AudioInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  delivered_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  listened_at?: InputMaybe<Scalars['Datetime']['input']>;
  md5_checksum?: InputMaybe<Scalars['String']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  video_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type AudioInsertResponse = {
  __typename?: 'audioInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Audio>;
};

export type AudioOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  delivered_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_deleted?: InputMaybe<OrderByDirection>;
  listened_at?: InputMaybe<OrderByDirection>;
  md5_checksum?: InputMaybe<OrderByDirection>;
  to_user_id?: InputMaybe<OrderByDirection>;
  transcription?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
  video_id?: InputMaybe<OrderByDirection>;
};

export type AudioUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  delivered_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  listened_at?: InputMaybe<Scalars['Datetime']['input']>;
  md5_checksum?: InputMaybe<Scalars['String']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  video_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type AudioUpdateResponse = {
  __typename?: 'audioUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Audio>;
};

export type Contact = Node & {
  __typename?: 'contact';
  created_at: Scalars['Datetime']['output'];
  from_phone_hash: Scalars['Opaque']['output'];
  is_blocked: Scalars['Boolean']['output'];
  last_interaction_at?: Maybe<Scalars['Datetime']['output']>;
  latest_notification_id?: Maybe<Scalars['UUID']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notification?: Maybe<Notification>;
  profile?: Maybe<Profile>;
  to_name?: Maybe<Scalars['String']['output']>;
  to_phone_hash: Scalars['Opaque']['output'];
  to_user_id?: Maybe<Scalars['UUID']['output']>;
  total_messages_sent_to?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['UUID']['output'];
};

export type ContactConnection = {
  __typename?: 'contactConnection';
  edges: Array<ContactEdge>;
  pageInfo: PageInfo;
};

export type ContactDeleteResponse = {
  __typename?: 'contactDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Contact>;
};

export type ContactEdge = {
  __typename?: 'contactEdge';
  cursor: Scalars['String']['output'];
  node: Contact;
};

export type ContactFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ContactFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  from_phone_hash?: InputMaybe<OpaqueFilter>;
  is_blocked?: InputMaybe<BooleanFilter>;
  last_interaction_at?: InputMaybe<DatetimeFilter>;
  latest_notification_id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ContactFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ContactFilter>>;
  to_name?: InputMaybe<StringFilter>;
  to_phone_hash?: InputMaybe<OpaqueFilter>;
  to_user_id?: InputMaybe<UuidFilter>;
  total_messages_sent_to?: InputMaybe<IntFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type ContactInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  from_phone_hash?: InputMaybe<Scalars['Opaque']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  last_interaction_at?: InputMaybe<Scalars['Datetime']['input']>;
  latest_notification_id?: InputMaybe<Scalars['UUID']['input']>;
  to_name?: InputMaybe<Scalars['String']['input']>;
  to_phone_hash?: InputMaybe<Scalars['Opaque']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  total_messages_sent_to?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContactInsertResponse = {
  __typename?: 'contactInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Contact>;
};

export type ContactOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  from_phone_hash?: InputMaybe<OrderByDirection>;
  is_blocked?: InputMaybe<OrderByDirection>;
  last_interaction_at?: InputMaybe<OrderByDirection>;
  latest_notification_id?: InputMaybe<OrderByDirection>;
  to_name?: InputMaybe<OrderByDirection>;
  to_phone_hash?: InputMaybe<OrderByDirection>;
  to_user_id?: InputMaybe<OrderByDirection>;
  total_messages_sent_to?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type ContactUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  from_phone_hash?: InputMaybe<Scalars['Opaque']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  last_interaction_at?: InputMaybe<Scalars['Datetime']['input']>;
  latest_notification_id?: InputMaybe<Scalars['UUID']['input']>;
  to_name?: InputMaybe<Scalars['String']['input']>;
  to_phone_hash?: InputMaybe<Scalars['Opaque']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  total_messages_sent_to?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContactUpdateResponse = {
  __typename?: 'contactUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Contact>;
};

export type Event = Node & {
  __typename?: 'event';
  created_at: Scalars['Datetime']['output'];
  created_by_user_id?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ends_at?: Maybe<Scalars['Datetime']['output']>;
  event_memberCollection?: Maybe<Event_MemberConnection>;
  event_ticket_kindCollection?: Maybe<Event_Ticket_KindConnection>;
  flyer_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  location_geo?: Maybe<Scalars['Opaque']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  location_neighborhood?: Maybe<Scalars['String']['output']>;
  location_place_id?: Maybe<Scalars['String']['output']>;
  location_postal_code?: Maybe<Scalars['String']['output']>;
  location_state?: Maybe<Scalars['String']['output']>;
  location_street?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  starts_at?: Maybe<Scalars['Datetime']['output']>;
  status: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Datetime']['output'];
  visibility: Scalars['String']['output'];
};


export type EventEvent_MemberCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Event_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Event_MemberOrderBy>>;
};


export type EventEvent_Ticket_KindCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Event_Ticket_KindFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Event_Ticket_KindOrderBy>>;
};

export type EventConnection = {
  __typename?: 'eventConnection';
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
};

export type EventDeleteResponse = {
  __typename?: 'eventDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event>;
};

export type EventEdge = {
  __typename?: 'eventEdge';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EventFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by_user_id?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  ends_at?: InputMaybe<DatetimeFilter>;
  flyer_url?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  location_city?: InputMaybe<StringFilter>;
  location_country?: InputMaybe<StringFilter>;
  location_geo?: InputMaybe<OpaqueFilter>;
  location_name?: InputMaybe<StringFilter>;
  location_neighborhood?: InputMaybe<StringFilter>;
  location_place_id?: InputMaybe<StringFilter>;
  location_postal_code?: InputMaybe<StringFilter>;
  location_state?: InputMaybe<StringFilter>;
  location_street?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<EventFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EventFilter>>;
  slug?: InputMaybe<StringFilter>;
  starts_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  timezone?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  visibility?: InputMaybe<StringFilter>;
};

export type EventInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  created_by_user_id?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ends_at?: InputMaybe<Scalars['Datetime']['input']>;
  flyer_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_country?: InputMaybe<Scalars['String']['input']>;
  location_geo?: InputMaybe<Scalars['Opaque']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  location_neighborhood?: InputMaybe<Scalars['String']['input']>;
  location_place_id?: InputMaybe<Scalars['String']['input']>;
  location_postal_code?: InputMaybe<Scalars['String']['input']>;
  location_state?: InputMaybe<Scalars['String']['input']>;
  location_street?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  starts_at?: InputMaybe<Scalars['Datetime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type EventInsertResponse = {
  __typename?: 'eventInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event>;
};

export type EventOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by_user_id?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  ends_at?: InputMaybe<OrderByDirection>;
  flyer_url?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  location_city?: InputMaybe<OrderByDirection>;
  location_country?: InputMaybe<OrderByDirection>;
  location_geo?: InputMaybe<OrderByDirection>;
  location_name?: InputMaybe<OrderByDirection>;
  location_neighborhood?: InputMaybe<OrderByDirection>;
  location_place_id?: InputMaybe<OrderByDirection>;
  location_postal_code?: InputMaybe<OrderByDirection>;
  location_state?: InputMaybe<OrderByDirection>;
  location_street?: InputMaybe<OrderByDirection>;
  slug?: InputMaybe<OrderByDirection>;
  starts_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  timezone?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  visibility?: InputMaybe<OrderByDirection>;
};

export type EventUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  created_by_user_id?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ends_at?: InputMaybe<Scalars['Datetime']['input']>;
  flyer_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_country?: InputMaybe<Scalars['String']['input']>;
  location_geo?: InputMaybe<Scalars['Opaque']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  location_neighborhood?: InputMaybe<Scalars['String']['input']>;
  location_place_id?: InputMaybe<Scalars['String']['input']>;
  location_postal_code?: InputMaybe<Scalars['String']['input']>;
  location_state?: InputMaybe<Scalars['String']['input']>;
  location_street?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  starts_at?: InputMaybe<Scalars['Datetime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type EventUpdateResponse = {
  __typename?: 'eventUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event>;
};

export type Event_Member = Node & {
  __typename?: 'event_member';
  created_at: Scalars['Datetime']['output'];
  event?: Maybe<Event>;
  event_id: Scalars['UUID']['output'];
  event_ticket_kind?: Maybe<Event_Ticket_Kind>;
  event_ticket_kind_id?: Maybe<Scalars['UUID']['output']>;
  invite_source?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  profile?: Maybe<Profile>;
  referred_by_user_id?: Maybe<Scalars['UUID']['output']>;
  role: Scalars['String']['output'];
  rsvp_status: Scalars['String']['output'];
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_intent_status?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['UUID']['output'];
};

export type Event_MemberConnection = {
  __typename?: 'event_memberConnection';
  edges: Array<Event_MemberEdge>;
  pageInfo: PageInfo;
};

export type Event_MemberDeleteResponse = {
  __typename?: 'event_memberDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event_Member>;
};

export type Event_MemberEdge = {
  __typename?: 'event_memberEdge';
  cursor: Scalars['String']['output'];
  node: Event_Member;
};

export type Event_MemberFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Event_MemberFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  event_id?: InputMaybe<UuidFilter>;
  event_ticket_kind_id?: InputMaybe<UuidFilter>;
  invite_source?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Event_MemberFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Event_MemberFilter>>;
  referred_by_user_id?: InputMaybe<UuidFilter>;
  role?: InputMaybe<StringFilter>;
  rsvp_status?: InputMaybe<StringFilter>;
  stripe_payment_intent_id?: InputMaybe<StringFilter>;
  stripe_payment_intent_status?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Event_MemberInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  event_id?: InputMaybe<Scalars['UUID']['input']>;
  event_ticket_kind_id?: InputMaybe<Scalars['UUID']['input']>;
  invite_source?: InputMaybe<Scalars['String']['input']>;
  referred_by_user_id?: InputMaybe<Scalars['UUID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  rsvp_status?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Event_MemberInsertResponse = {
  __typename?: 'event_memberInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event_Member>;
};

export type Event_MemberOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  event_id?: InputMaybe<OrderByDirection>;
  event_ticket_kind_id?: InputMaybe<OrderByDirection>;
  invite_source?: InputMaybe<OrderByDirection>;
  referred_by_user_id?: InputMaybe<OrderByDirection>;
  role?: InputMaybe<OrderByDirection>;
  rsvp_status?: InputMaybe<OrderByDirection>;
  stripe_payment_intent_id?: InputMaybe<OrderByDirection>;
  stripe_payment_intent_status?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Event_MemberUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  event_id?: InputMaybe<Scalars['UUID']['input']>;
  event_ticket_kind_id?: InputMaybe<Scalars['UUID']['input']>;
  invite_source?: InputMaybe<Scalars['String']['input']>;
  referred_by_user_id?: InputMaybe<Scalars['UUID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  rsvp_status?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  stripe_payment_intent_status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Event_MemberUpdateResponse = {
  __typename?: 'event_memberUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event_Member>;
};

export type Event_Ticket_Kind = Node & {
  __typename?: 'event_ticket_kind';
  created_at: Scalars['Datetime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  event_id: Scalars['UUID']['output'];
  event_memberCollection?: Maybe<Event_MemberConnection>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  price_cents: Scalars['Int']['output'];
  price_service_fee: Scalars['Int']['output'];
  quantity_sold: Scalars['Int']['output'];
  quantity_total?: Maybe<Scalars['Int']['output']>;
  sales_end_at?: Maybe<Scalars['Datetime']['output']>;
  sales_start_at?: Maybe<Scalars['Datetime']['output']>;
  sort_order: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};


export type Event_Ticket_KindEvent_MemberCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Event_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Event_MemberOrderBy>>;
};

export type Event_Ticket_KindConnection = {
  __typename?: 'event_ticket_kindConnection';
  edges: Array<Event_Ticket_KindEdge>;
  pageInfo: PageInfo;
};

export type Event_Ticket_KindDeleteResponse = {
  __typename?: 'event_ticket_kindDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event_Ticket_Kind>;
};

export type Event_Ticket_KindEdge = {
  __typename?: 'event_ticket_kindEdge';
  cursor: Scalars['String']['output'];
  node: Event_Ticket_Kind;
};

export type Event_Ticket_KindFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Event_Ticket_KindFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  event_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Event_Ticket_KindFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Event_Ticket_KindFilter>>;
  price_cents?: InputMaybe<IntFilter>;
  price_service_fee?: InputMaybe<IntFilter>;
  quantity_sold?: InputMaybe<IntFilter>;
  quantity_total?: InputMaybe<IntFilter>;
  sales_end_at?: InputMaybe<DatetimeFilter>;
  sales_start_at?: InputMaybe<DatetimeFilter>;
  sort_order?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringFilter>;
};

export type Event_Ticket_KindInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price_cents?: InputMaybe<Scalars['Int']['input']>;
  price_service_fee?: InputMaybe<Scalars['Int']['input']>;
  quantity_sold?: InputMaybe<Scalars['Int']['input']>;
  quantity_total?: InputMaybe<Scalars['Int']['input']>;
  sales_end_at?: InputMaybe<Scalars['Datetime']['input']>;
  sales_start_at?: InputMaybe<Scalars['Datetime']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Ticket_KindInsertResponse = {
  __typename?: 'event_ticket_kindInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event_Ticket_Kind>;
};

export type Event_Ticket_KindOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  currency?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  event_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  price_cents?: InputMaybe<OrderByDirection>;
  price_service_fee?: InputMaybe<OrderByDirection>;
  quantity_sold?: InputMaybe<OrderByDirection>;
  quantity_total?: InputMaybe<OrderByDirection>;
  sales_end_at?: InputMaybe<OrderByDirection>;
  sales_start_at?: InputMaybe<OrderByDirection>;
  sort_order?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
};

export type Event_Ticket_KindUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price_cents?: InputMaybe<Scalars['Int']['input']>;
  price_service_fee?: InputMaybe<Scalars['Int']['input']>;
  quantity_sold?: InputMaybe<Scalars['Int']['input']>;
  quantity_total?: InputMaybe<Scalars['Int']['input']>;
  sales_end_at?: InputMaybe<Scalars['Datetime']['input']>;
  sales_start_at?: InputMaybe<Scalars['Datetime']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Event_Ticket_KindUpdateResponse = {
  __typename?: 'event_ticket_kindUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Event_Ticket_Kind>;
};

export type Feed = Node & {
  __typename?: 'feed';
  created_at: Scalars['Datetime']['output'];
  created_via: Scalars['String']['output'];
  from_user_id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  reaction?: Maybe<Scalars['String']['output']>;
  to_user_id: Scalars['UUID']['output'];
  video?: Maybe<Video>;
  video_id: Scalars['UUID']['output'];
  watch_count: Scalars['BigInt']['output'];
  watched_at?: Maybe<Scalars['Datetime']['output']>;
};

export type FeedConnection = {
  __typename?: 'feedConnection';
  edges: Array<FeedEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars['Int']['output'];
};

export type FeedDeleteResponse = {
  __typename?: 'feedDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Feed>;
};

export type FeedEdge = {
  __typename?: 'feedEdge';
  cursor: Scalars['String']['output'];
  node: Feed;
};

export type FeedFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<FeedFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_via?: InputMaybe<StringFilter>;
  from_user_id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<FeedFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<FeedFilter>>;
  reaction?: InputMaybe<StringFilter>;
  to_user_id?: InputMaybe<UuidFilter>;
  video_id?: InputMaybe<UuidFilter>;
  watch_count?: InputMaybe<BigIntFilter>;
  watched_at?: InputMaybe<DatetimeFilter>;
};

export type FeedInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  created_via?: InputMaybe<Scalars['String']['input']>;
  from_user_id?: InputMaybe<Scalars['UUID']['input']>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  video_id?: InputMaybe<Scalars['UUID']['input']>;
  watch_count?: InputMaybe<Scalars['BigInt']['input']>;
  watched_at?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FeedInsertResponse = {
  __typename?: 'feedInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Feed>;
};

export type FeedOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_via?: InputMaybe<OrderByDirection>;
  from_user_id?: InputMaybe<OrderByDirection>;
  reaction?: InputMaybe<OrderByDirection>;
  to_user_id?: InputMaybe<OrderByDirection>;
  video_id?: InputMaybe<OrderByDirection>;
  watch_count?: InputMaybe<OrderByDirection>;
  watched_at?: InputMaybe<OrderByDirection>;
};

export type FeedUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  created_via?: InputMaybe<Scalars['String']['input']>;
  from_user_id?: InputMaybe<Scalars['UUID']['input']>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  video_id?: InputMaybe<Scalars['UUID']['input']>;
  watch_count?: InputMaybe<Scalars['BigInt']['input']>;
  watched_at?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FeedUpdateResponse = {
  __typename?: 'feedUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Feed>;
};

export type File = Node & {
  __typename?: 'file';
  content_type: Scalars['String']['output'];
  created_at: Scalars['Datetime']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  file_extension?: Maybe<Scalars['String']['output']>;
  file_key: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  is_complete: Scalars['Boolean']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  parts_total?: Maybe<Scalars['Int']['output']>;
  parts_uploaded?: Maybe<Scalars['Int']['output']>;
  size_bytes?: Maybe<Scalars['BigInt']['output']>;
  updated_at: Scalars['Datetime']['output'];
  upload_id?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user_id: Scalars['UUID']['output'];
};

export type FileConnection = {
  __typename?: 'fileConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
};

export type FileDeleteResponse = {
  __typename?: 'fileDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<File>;
};

export type FileEdge = {
  __typename?: 'fileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type FileFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<FileFilter>>;
  content_type?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  error_message?: InputMaybe<StringFilter>;
  file_extension?: InputMaybe<StringFilter>;
  file_key?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_complete?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<FileFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<FileFilter>>;
  parts_total?: InputMaybe<IntFilter>;
  parts_uploaded?: InputMaybe<IntFilter>;
  size_bytes?: InputMaybe<BigIntFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  upload_id?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type FileInsertInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  file_extension?: InputMaybe<Scalars['String']['input']>;
  file_key?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  parts_total?: InputMaybe<Scalars['Int']['input']>;
  parts_uploaded?: InputMaybe<Scalars['Int']['input']>;
  size_bytes?: InputMaybe<Scalars['BigInt']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  upload_id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type FileInsertResponse = {
  __typename?: 'fileInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<File>;
};

export type FileOrderBy = {
  content_type?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  error_message?: InputMaybe<OrderByDirection>;
  file_extension?: InputMaybe<OrderByDirection>;
  file_key?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_complete?: InputMaybe<OrderByDirection>;
  parts_total?: InputMaybe<OrderByDirection>;
  parts_uploaded?: InputMaybe<OrderByDirection>;
  size_bytes?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  upload_id?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type FileUpdateInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  file_extension?: InputMaybe<Scalars['String']['input']>;
  file_key?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  parts_total?: InputMaybe<Scalars['Int']['input']>;
  parts_uploaded?: InputMaybe<Scalars['Int']['input']>;
  size_bytes?: InputMaybe<Scalars['BigInt']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  upload_id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type FileUpdateResponse = {
  __typename?: 'fileUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<File>;
};

export type Notification = Node & {
  __typename?: 'notification';
  audio?: Maybe<Audio>;
  audio_id?: Maybe<Scalars['UUID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  contactCollection?: Maybe<ContactConnection>;
  created_at: Scalars['Datetime']['output'];
  from_user_id?: Maybe<Scalars['UUID']['output']>;
  has_seen: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  is_automated?: Maybe<Scalars['Boolean']['output']>;
  is_sent: Scalars['Boolean']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  preferred_send_method: Scalars['String']['output'];
  sent_at?: Maybe<Scalars['Datetime']['output']>;
  sent_via?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  to_user_id: Scalars['UUID']['output'];
  video?: Maybe<Video>;
  video_id?: Maybe<Scalars['UUID']['output']>;
};


export type NotificationContactCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContactOrderBy>>;
};

export type NotificationConnection = {
  __typename?: 'notificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type NotificationDeleteResponse = {
  __typename?: 'notificationDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Notification>;
};

export type NotificationEdge = {
  __typename?: 'notificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type NotificationFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NotificationFilter>>;
  audio_id?: InputMaybe<UuidFilter>;
  body?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  from_user_id?: InputMaybe<UuidFilter>;
  has_seen?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<UuidFilter>;
  is_automated?: InputMaybe<BooleanFilter>;
  is_sent?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NotificationFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NotificationFilter>>;
  preferred_send_method?: InputMaybe<StringFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  sent_via?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  to_user_id?: InputMaybe<UuidFilter>;
  video_id?: InputMaybe<UuidFilter>;
};

export type NotificationInsertInput = {
  audio_id?: InputMaybe<Scalars['UUID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  from_user_id?: InputMaybe<Scalars['UUID']['input']>;
  has_seen?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_automated?: InputMaybe<Scalars['Boolean']['input']>;
  is_sent?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_send_method?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['Datetime']['input']>;
  sent_via?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  video_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationInsertResponse = {
  __typename?: 'notificationInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Notification>;
};

export type NotificationOrderBy = {
  audio_id?: InputMaybe<OrderByDirection>;
  body?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  from_user_id?: InputMaybe<OrderByDirection>;
  has_seen?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_automated?: InputMaybe<OrderByDirection>;
  is_sent?: InputMaybe<OrderByDirection>;
  preferred_send_method?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  sent_via?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  to_user_id?: InputMaybe<OrderByDirection>;
  video_id?: InputMaybe<OrderByDirection>;
};

export type NotificationUpdateInput = {
  audio_id?: InputMaybe<Scalars['UUID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  from_user_id?: InputMaybe<Scalars['UUID']['input']>;
  has_seen?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_automated?: InputMaybe<Scalars['Boolean']['input']>;
  is_sent?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_send_method?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['Datetime']['input']>;
  sent_via?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to_user_id?: InputMaybe<Scalars['UUID']['input']>;
  video_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationUpdateResponse = {
  __typename?: 'notificationUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Notification>;
};

export type Profile = Node & {
  __typename?: 'profile';
  ambassador_email?: Maybe<Scalars['String']['output']>;
  contactCollection?: Maybe<ContactConnection>;
  created_at: Scalars['Datetime']['output'];
  event_memberCollection?: Maybe<Event_MemberConnection>;
  expo_push_token?: Maybe<Scalars['String']['output']>;
  last_notification_sent_at?: Maybe<Scalars['Datetime']['output']>;
  location?: Maybe<Scalars['Opaque']['output']>;
  metadata: Scalars['JSON']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  phone_hash?: Maybe<Scalars['Opaque']['output']>;
  stripe_account_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Datetime']['output'];
  user_id: Scalars['UUID']['output'];
  utc_offset_hours: Scalars['Int']['output'];
};


export type ProfileContactCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContactOrderBy>>;
};


export type ProfileEvent_MemberCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Event_MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Event_MemberOrderBy>>;
};

export type ProfileConnection = {
  __typename?: 'profileConnection';
  edges: Array<ProfileEdge>;
  pageInfo: PageInfo;
};

export type ProfileDeleteResponse = {
  __typename?: 'profileDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Profile>;
};

export type ProfileEdge = {
  __typename?: 'profileEdge';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type ProfileFilter = {
  ambassador_email?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ProfileFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  expo_push_token?: InputMaybe<StringFilter>;
  last_notification_sent_at?: InputMaybe<DatetimeFilter>;
  location?: InputMaybe<OpaqueFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ProfileFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ProfileFilter>>;
  phone_hash?: InputMaybe<OpaqueFilter>;
  stripe_account_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
  utc_offset_hours?: InputMaybe<IntFilter>;
};

export type ProfileInsertInput = {
  ambassador_email?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  expo_push_token?: InputMaybe<Scalars['String']['input']>;
  last_notification_sent_at?: InputMaybe<Scalars['Datetime']['input']>;
  location?: InputMaybe<Scalars['Opaque']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_hash?: InputMaybe<Scalars['Opaque']['input']>;
  stripe_account_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  utc_offset_hours?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileInsertResponse = {
  __typename?: 'profileInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Profile>;
};

export type ProfileOrderBy = {
  ambassador_email?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  expo_push_token?: InputMaybe<OrderByDirection>;
  last_notification_sent_at?: InputMaybe<OrderByDirection>;
  location?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  phone_hash?: InputMaybe<OrderByDirection>;
  stripe_account_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
  utc_offset_hours?: InputMaybe<OrderByDirection>;
};

export type ProfileUpdateInput = {
  ambassador_email?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  expo_push_token?: InputMaybe<Scalars['String']['input']>;
  last_notification_sent_at?: InputMaybe<Scalars['Datetime']['input']>;
  location?: InputMaybe<Scalars['Opaque']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_hash?: InputMaybe<Scalars['Opaque']['input']>;
  stripe_account_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
  utc_offset_hours?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileUpdateResponse = {
  __typename?: 'profileUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Profile>;
};

export type Prompt = Node & {
  __typename?: 'prompt';
  created_at: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  is_visible: Scalars['Boolean']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type PromptConnection = {
  __typename?: 'promptConnection';
  edges: Array<PromptEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars['Int']['output'];
};

export type PromptDeleteResponse = {
  __typename?: 'promptDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Prompt>;
};

export type PromptEdge = {
  __typename?: 'promptEdge';
  cursor: Scalars['String']['output'];
  node: Prompt;
};

export type PromptFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<PromptFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_visible?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<PromptFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<PromptFilter>>;
  text?: InputMaybe<StringFilter>;
};

export type PromptInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PromptInsertResponse = {
  __typename?: 'promptInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Prompt>;
};

export type PromptOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_visible?: InputMaybe<OrderByDirection>;
  text?: InputMaybe<OrderByDirection>;
};

export type PromptUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PromptUpdateResponse = {
  __typename?: 'promptUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Prompt>;
};

export type Spatial_Ref_Sys = Node & {
  __typename?: 'spatial_ref_sys';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  proj4text?: Maybe<Scalars['String']['output']>;
  srid: Scalars['Int']['output'];
  srtext?: Maybe<Scalars['String']['output']>;
};

export type Spatial_Ref_SysConnection = {
  __typename?: 'spatial_ref_sysConnection';
  edges: Array<Spatial_Ref_SysEdge>;
  pageInfo: PageInfo;
};

export type Spatial_Ref_SysEdge = {
  __typename?: 'spatial_ref_sysEdge';
  cursor: Scalars['String']['output'];
  node: Spatial_Ref_Sys;
};

export type Spatial_Ref_SysFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Spatial_Ref_SysFilter>>;
  auth_name?: InputMaybe<StringFilter>;
  auth_srid?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Spatial_Ref_SysFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Spatial_Ref_SysFilter>>;
  proj4text?: InputMaybe<StringFilter>;
  srid?: InputMaybe<IntFilter>;
  srtext?: InputMaybe<StringFilter>;
};

export type Spatial_Ref_SysOrderBy = {
  auth_name?: InputMaybe<OrderByDirection>;
  auth_srid?: InputMaybe<OrderByDirection>;
  proj4text?: InputMaybe<OrderByDirection>;
  srid?: InputMaybe<OrderByDirection>;
  srtext?: InputMaybe<OrderByDirection>;
};

export type Video = Node & {
  __typename?: 'video';
  audioCollection?: Maybe<AudioConnection>;
  created_at: Scalars['Datetime']['output'];
  created_at_tz?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  feedCollection?: Maybe<FeedConnection>;
  id: Scalars['UUID']['output'];
  is_deleted: Scalars['Boolean']['output'];
  is_live: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['Opaque']['output']>;
  md5_checksum: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notificationCollection?: Maybe<NotificationConnection>;
  object_id?: Maybe<Scalars['UUID']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  prompt_text?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  stream_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  uploaded_text?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user_id: Scalars['UUID']['output'];
};


export type VideoAudioCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AudioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AudioOrderBy>>;
};


export type VideoFeedCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FeedFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeedOrderBy>>;
};


export type VideoNotificationCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderBy>>;
};

export type VideoConnection = {
  __typename?: 'videoConnection';
  edges: Array<VideoEdge>;
  pageInfo: PageInfo;
};

export type VideoDeleteResponse = {
  __typename?: 'videoDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Video>;
};

export type VideoEdge = {
  __typename?: 'videoEdge';
  cursor: Scalars['String']['output'];
  node: Video;
};

export type VideoFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<VideoFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_at_tz?: InputMaybe<StringFilter>;
  duration?: InputMaybe<FloatFilter>;
  id?: InputMaybe<UuidFilter>;
  is_deleted?: InputMaybe<BooleanFilter>;
  is_live?: InputMaybe<BooleanFilter>;
  is_public?: InputMaybe<BooleanFilter>;
  location?: InputMaybe<OpaqueFilter>;
  md5_checksum?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<VideoFilter>;
  object_id?: InputMaybe<UuidFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<VideoFilter>>;
  orientation?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  platform?: InputMaybe<StringFilter>;
  prompt_text?: InputMaybe<StringFilter>;
  score?: InputMaybe<IntFilter>;
  stream_url?: InputMaybe<StringFilter>;
  thumbnail_url?: InputMaybe<StringFilter>;
  uploaded_text?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type VideoInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  created_at_tz?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_live?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Opaque']['input']>;
  md5_checksum?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  object_id?: InputMaybe<Scalars['UUID']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  prompt_text?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  stream_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  uploaded_text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type VideoInsertResponse = {
  __typename?: 'videoInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Video>;
};

export type VideoOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_at_tz?: InputMaybe<OrderByDirection>;
  duration?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_deleted?: InputMaybe<OrderByDirection>;
  is_live?: InputMaybe<OrderByDirection>;
  is_public?: InputMaybe<OrderByDirection>;
  location?: InputMaybe<OrderByDirection>;
  md5_checksum?: InputMaybe<OrderByDirection>;
  object_id?: InputMaybe<OrderByDirection>;
  orientation?: InputMaybe<OrderByDirection>;
  path?: InputMaybe<OrderByDirection>;
  platform?: InputMaybe<OrderByDirection>;
  prompt_text?: InputMaybe<OrderByDirection>;
  score?: InputMaybe<OrderByDirection>;
  stream_url?: InputMaybe<OrderByDirection>;
  thumbnail_url?: InputMaybe<OrderByDirection>;
  uploaded_text?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type VideoUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  created_at_tz?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_live?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Opaque']['input']>;
  md5_checksum?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  object_id?: InputMaybe<Scalars['UUID']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  prompt_text?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  stream_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  uploaded_text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type VideoUpdateResponse = {
  __typename?: 'videoUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Video>;
};

export type EventBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type EventBySlugQuery = { __typename?: 'Query', eventCollection?: { __typename?: 'eventConnection', edges: Array<{ __typename?: 'eventEdge', node: { __typename?: 'event', id: string, title?: string | null, description?: string | null, slug: string, status: string, visibility: string, starts_at?: string | null, ends_at?: string | null, flyer_url?: string | null, location_name?: string | null, location_street?: string | null, location_city?: string | null, location_state?: string | null, location_postal_code?: string | null, location_geo?: string | null, location_place_id?: string | null, location_neighborhood?: string | null, location_country?: string | null, timezone: string, event_ticket_kindCollection?: { __typename?: 'event_ticket_kindConnection', edges: Array<{ __typename?: 'event_ticket_kindEdge', node: { __typename?: 'event_ticket_kind', id: string, currency: string, description?: string | null, name: string, price_cents: number, price_service_fee: number, quantity_total?: number | null, quantity_sold: number, status: string } }> } | null, event_memberCollection?: { __typename?: 'event_memberConnection', edges: Array<{ __typename?: 'event_memberEdge', node: { __typename?: 'event_member', user_id: string, role: string, rsvp_status: string } }> } | null } }> } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  set: EventUpdateInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateeventCollection: { __typename?: 'eventUpdateResponse', affectedCount: number } };

export type ReplaceTicketKindMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  newTicket: Event_Ticket_KindInsertInput;
}>;


export type ReplaceTicketKindMutation = { __typename?: 'Mutation', updateevent_ticket_kindCollection: { __typename?: 'event_ticket_kindUpdateResponse', affectedCount: number }, insertIntoevent_ticket_kindCollection?: { __typename?: 'event_ticket_kindInsertResponse', records: Array<{ __typename?: 'event_ticket_kind', id: string }> } | null };

export type UpcomingEventsQueryVariables = Exact<{
  now: Scalars['Datetime']['input'];
}>;


export type UpcomingEventsQuery = { __typename?: 'Query', eventCollection?: { __typename?: 'eventConnection', edges: Array<{ __typename?: 'eventEdge', node: { __typename?: 'event', id: string, title?: string | null, description?: string | null, slug: string, status: string, visibility: string, starts_at?: string | null, ends_at?: string | null, flyer_url?: string | null, created_by_user_id?: string | null, location_name?: string | null, location_street?: string | null, location_city?: string | null, location_state?: string | null, location_postal_code?: string | null, location_geo?: string | null, location_place_id?: string | null, location_neighborhood?: string | null, event_ticket_kindCollection?: { __typename?: 'event_ticket_kindConnection', edges: Array<{ __typename?: 'event_ticket_kindEdge', node: { __typename?: 'event_ticket_kind', id: string, currency: string, description?: string | null, name: string, price_cents: number, price_service_fee: number, quantity_total?: number | null, quantity_sold: number, status: string } }> } | null, event_memberCollection?: { __typename?: 'event_memberConnection', edges: Array<{ __typename?: 'event_memberEdge', node: { __typename?: 'event_member', user_id: string, role: string, rsvp_status: string } }> } | null } }> } | null };

export type PastUserEventsQueryVariables = Exact<{
  now: Scalars['Datetime']['input'];
}>;


export type PastUserEventsQuery = { __typename?: 'Query', eventCollection?: { __typename?: 'eventConnection', edges: Array<{ __typename?: 'eventEdge', node: { __typename?: 'event', id: string, title?: string | null, description?: string | null, slug: string, status: string, visibility: string, starts_at?: string | null, ends_at?: string | null, flyer_url?: string | null, created_by_user_id?: string | null, location_name?: string | null, location_street?: string | null, location_city?: string | null, location_state?: string | null, location_postal_code?: string | null, location_geo?: string | null, location_place_id?: string | null, location_neighborhood?: string | null, event_ticket_kindCollection?: { __typename?: 'event_ticket_kindConnection', edges: Array<{ __typename?: 'event_ticket_kindEdge', node: { __typename?: 'event_ticket_kind', id: string, currency: string, description?: string | null, name: string, price_cents: number, price_service_fee: number, quantity_total?: number | null, quantity_sold: number, status: string } }> } | null, event_memberCollection?: { __typename?: 'event_memberConnection', edges: Array<{ __typename?: 'event_memberEdge', node: { __typename?: 'event_member', user_id: string, role: string, rsvp_status: string } }> } | null } }> } | null };


export const EventBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"starts_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"flyer_url"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"location_street"}},{"kind":"Field","name":{"kind":"Name","value":"location_city"}},{"kind":"Field","name":{"kind":"Name","value":"location_state"}},{"kind":"Field","name":{"kind":"Name","value":"location_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"location_geo"}},{"kind":"Field","name":{"kind":"Name","value":"location_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"location_country"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"event_ticket_kindCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price_cents"}},{"kind":"Field","name":{"kind":"Name","value":"price_service_fee"}},{"kind":"Field","name":{"kind":"Name","value":"quantity_total"}},{"kind":"Field","name":{"kind":"Name","value":"quantity_sold"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event_memberCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"rsvp_status"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventBySlugQuery, EventBySlugQueryVariables>;
export const UpdateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eventUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateeventCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedCount"}}]}}]}}]} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const ReplaceTicketKindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplaceTicketKind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTicket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"event_ticket_kindInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateevent_ticket_kindCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"StringValue","value":"hidden","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"hidden","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"atMost"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertIntoevent_ticket_kindCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"newTicket"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ReplaceTicketKindMutation, ReplaceTicketKindMutationVariables>;
export const UpcomingEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpcomingEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ends_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"StringValue","value":"draft","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"starts_at"},"value":{"kind":"EnumValue","value":"AscNullsLast"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"starts_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"flyer_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"location_street"}},{"kind":"Field","name":{"kind":"Name","value":"location_city"}},{"kind":"Field","name":{"kind":"Name","value":"location_state"}},{"kind":"Field","name":{"kind":"Name","value":"location_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"location_geo"}},{"kind":"Field","name":{"kind":"Name","value":"location_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"event_ticket_kindCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price_cents"}},{"kind":"Field","name":{"kind":"Name","value":"price_service_fee"}},{"kind":"Field","name":{"kind":"Name","value":"quantity_total"}},{"kind":"Field","name":{"kind":"Name","value":"quantity_sold"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event_memberCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"rsvp_status"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpcomingEventsQuery, UpcomingEventsQueryVariables>;
export const PastUserEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PastUserEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ends_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"starts_at"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"starts_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"flyer_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"location_street"}},{"kind":"Field","name":{"kind":"Name","value":"location_city"}},{"kind":"Field","name":{"kind":"Name","value":"location_state"}},{"kind":"Field","name":{"kind":"Name","value":"location_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"location_geo"}},{"kind":"Field","name":{"kind":"Name","value":"location_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"event_ticket_kindCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price_cents"}},{"kind":"Field","name":{"kind":"Name","value":"price_service_fee"}},{"kind":"Field","name":{"kind":"Name","value":"quantity_total"}},{"kind":"Field","name":{"kind":"Name","value":"quantity_sold"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event_memberCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"rsvp_status"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PastUserEventsQuery, PastUserEventsQueryVariables>;